// 所属服务 serviceTool 业务工具,publicTool 公共工具
const service = "serviceTool";
// 前台路由
const web_routers = {
  path: "dataAcquisition",
  name: "dataAcquisition",
  redirect: { name: "dataAcquisitionIndex" },
  component: {
    render: (e) => e("router-view"),
  },
  meta: {
    title: "数据采集",
    icon: "",
  },
  children: [
    {
      path: "dataAcquisitionIndex",
      name: "dataAcquisitionIndex",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/forestage/dataAcquisitionIndex/DataAcquisitionIndex.vue"
        ),
      meta: {
        title: "数据采集",
        icon: "icon-quanbu",
      },
      children: [],
    },
    {
      path: "dataAcquisitionDetail",
      name: "dataAcquisitionDetail",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/forestage/dataAcquisitionIndex/DataAcquisitionDetail.vue"
        ),
      meta: {
        title: "数据采集详情",
        icon: "icon-quanbu",
      },
      children: [],
    },
    {
      path: "dataAcquisitionDetailForm",
      name: "dataAcquisitionDetailForm",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/forestage/dataAcquisitionIndex/DataAcquisitionDetailForm.vue"
        ),
      meta: {
        title: "填报数据",
        icon: "icon-quanbu",
      },
      children: [],
    },
    {
      path: "fillingRecordsDetail",
      name: "fillingRecordsDetail",
      component: () =>
        import(
          /* webpackChunkName: "[request]" */ "../views/forestage/dataAcquisitionIndex/FillingRecordsDetail.vue"
        ),
      meta: {
        title: "填报记录",
        icon: "icon-quanbu",
      },
      children: [],
    },
  ],
};
// 后台路由
const cms_routers = undefined;
export default {
  service,
  web: web_routers,
  cms: cms_routers,
};
